export const formatNumber = number => {
  return number !== null ? Number(number).toFixed(2) : '0';
};
